module.exports = __webpack_public_path__ + "common/components/IconDS22/977d578ffeb7ff7b92112578efdec16f.svg";